function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
/* eslint-disable max-len */
import React from 'react';
import withCssProps from '../../../hocs/withCssProps';
import { StyledIcon } from './StyledIcon';
export var IagrofyLogoFull3 = withCssProps(function (props) {
  return /*#__PURE__*/React.createElement(StyledIcon, _extends({
    width: "148",
    height: "35",
    viewBox: "0 0 148 35",
    notChangeable: true,
    xmlns: "http://www.w3.org/2000/svg"
  }, props), /*#__PURE__*/React.createElement("path", {
    d: "M29.4943 0H0V29.7911H29.4943V0Z",
    fill: "#63A105"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26.7155 2.84766H2.76367V4.82764H26.7155V2.84766Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26.7155 7.26562H2.76367V9.24561H26.7155V7.26562Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26.7155 16.1289H2.76367V18.1089H26.7155V16.1289Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.6555 20.5469H2.76367V22.5269H12.6555V20.5469Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26.7307 20.5469H16.8389V22.5269H26.7307V20.5469Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.6555 11.6953H2.76367V13.6753H12.6555V11.6953Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26.7307 11.6953H16.8389V13.6753H26.7307V11.6953Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.6555 24.9766H2.76367V26.9565H12.6555V24.9766Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26.7307 24.9766H16.8389V26.9565H26.7307V24.9766Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M43.8412 2.65234H49.5347L58.6714 26.7624H53.7481L51.9359 21.9343H41.2134L39.371 26.7624H34.4326L43.8412 2.65234ZM42.4518 18.2485H50.7126L46.6804 7.57184L42.4518 18.2485Z",
    fill: "#0B0D1D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M101.319 7.70703C107.013 7.70703 111.106 11.8955 111.106 17.5308C111.106 23.09 107.013 27.2479 101.319 27.2479C95.6864 27.2479 91.5938 23.1052 91.5938 17.5308C91.5938 11.8802 95.6864 7.70703 101.319 7.70703ZM101.319 22.694C104.37 22.694 106.424 20.4246 106.424 17.5156C106.424 14.5304 104.385 12.2305 101.319 12.2305C98.3293 12.2305 96.2754 14.5304 96.2754 17.5156C96.2754 20.4246 98.3293 22.694 101.319 22.694Z",
    fill: "#0B0D1D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M122.176 5.66416C123.324 5.66416 124.502 6.16677 125.227 6.65415V1.91742C124.245 1.58235 122.961 1.29297 121.617 1.29297C117.238 1.29297 115.365 4.30863 115.365 7.88783V9.16721H112.027V13.0358H115.38V26.8347H120.243V13.0358H125.695V9.16721H120.243V7.91829C120.243 6.51708 120.787 5.66416 122.176 5.66416Z",
    fill: "#0B0D1D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M88.2113 7.98047C87.6827 7.98047 87.1994 8.04139 86.7615 8.14801H86.7464C86.5803 8.17847 84.9039 8.58969 83.8921 9.47307V8.17847H78.999V26.836H83.8921V19.1902C83.8921 19.1902 83.8921 19.1902 83.9072 19.1902V16.9056C83.9072 14.1336 85.0852 12.5497 87.4562 12.5497C89.0117 12.5497 90.3256 13.0523 90.7182 13.433V8.48308C90.1141 8.20893 89.2231 7.98047 88.2113 7.98047Z",
    fill: "#0B0D1D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M142.579 9.15234L138.199 21.215L132.793 9.15234H127.432L135.874 26.8351L135.285 28.3429C134.59 29.9574 133.865 30.7494 132.279 30.7494C130.165 30.7342 129.682 30.0488 129.138 29.5157V34.2677C130.014 34.6637 131.132 34.9683 132.279 34.9683C136.327 34.9683 138.652 32.836 140.45 28.1449L148.001 9.15234H142.579Z",
    fill: "#0B0D1D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M72.2478 8.20975V10.1136C71.0397 8.89513 69.2425 8.16406 66.8111 8.16406C61.767 8.16406 58.3389 12.322 58.3389 17.4243C58.3389 22.4656 61.767 26.6084 66.8111 26.6084C69.1368 26.6084 70.9642 25.8316 72.2478 24.6588V26.3951C72.2478 29.5936 70.1638 30.7206 67.8834 30.7206C65.1952 30.7206 63.7303 30.279 62.507 29.5327V34.0562C63.8058 34.6349 65.316 35.0005 67.8229 35.0005C73.2899 35.0005 77.0956 31.7563 77.0956 25.329V8.20975H72.2478ZM72.2478 20.379C71.3115 21.369 69.7862 22.1458 68.1703 22.1458C65.1952 22.1458 63.2923 20.1963 63.2923 17.4395C63.2923 14.6523 65.165 12.6571 68.1703 12.6571C69.8315 12.6571 71.4172 13.5405 72.2478 14.4543V20.379Z",
    fill: "#0B0D1D"
  }));
});